import 'alpinejs';
import 'typeface-fira-mono';
import 'typeface-inter';
